export default __webpack_public_path__ + "static/media/588.39987f1a.jpg";